import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from '@app/_services';
import { environment } from '@environments/environment';
import { faPaperPlane,faArrowLeft, faPhoneAlt, faUser, faEnvelope, faKey, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';


@Component({
    selector: 'app-delete-account',
    templateUrl: './delete-account.component.html',
    styleUrls: ['./delete-account.component.css'],
    standalone: false
})
export class DeleteAccountComponent {

  deleteAccountForm! : FormGroup;
  deleteAccountFormConfirm! : FormGroup;

  loading = false;
  submitted = false;

  faUser = faUser;
  faEnvelope = faEnvelope;
  faPaperPlane = faPaperPlane;
  faKey = faKey;

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  fullNamePattern = "^[A-Za-z -]{5,40}[A-Za-z -]+";


  action: any;

  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private route: ActivatedRoute,
    private userService: UserService, private router: Router
  ) 
  {
    
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => this.action = params['action']);

    this.deleteAccountForm = this.formBuilder.group({  
      fullname: ['', [Validators.required, Validators.pattern(this.fullNamePattern)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]]
    });

    this.deleteAccountFormConfirm = this.formBuilder.group({  
      tokencode: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]]
    });

  }

  get f() { return this.deleteAccountForm.controls; }

  get fc() { return this.deleteAccountFormConfirm.controls; }


  onSubmitConfirm(): void {
    this.submitted = true;
    
    if (!environment.production) {
      console.log('Is form invalid: ', this.deleteAccountFormConfirm.invalid);
      console.log('Form object: ', this.deleteAccountFormConfirm);
    }

    if (this.deleteAccountFormConfirm.invalid) 
    {
        //this.submitted = false;
        return;
    }

    let data = this.deleteAccountFormConfirm.value;

    if (!environment.production) {
      console.log('Data submitted: New : ', data);
    }


    this.userService.confirmUserDeletion(data).subscribe(
      data => {
        this.toastr.success(data.message, 'Success');
        //this.router.navigate(['/manage-numbers/list']);
        this.router.navigate(['/home']);

      }, 
      error => {
        this.toastr.error(error, 'Error');
        //this.loading = false;
      }
    );

  }

  onSubmit(): void {
    this.submitted = true;
    
    if (!environment.production) {
      console.log('Is form invalid: ', this.deleteAccountForm.invalid);
      console.log('Form object: ', this.deleteAccountForm);
    }

    if (this.deleteAccountForm.invalid) 
    {
        //this.submitted = false;
        return;
    }


    let data = this.deleteAccountForm.value;

    if (!environment.production) {
      console.log('Data submitted: New : ', data);
    }


    this.userService.requestUserDeletion(data).subscribe(
      data => {
        this.toastr.success(data.message, 'Success');
        //this.router.navigate(['/manage-numbers/list']);
        this.router.navigate(['/home']);

      }, 
      error => {
        this.toastr.error(error.message, 'Error');
        //this.loading = false;
      }
    );
    

  }

}
